import {Color} from '~/constants/style';

export const titleStyle = {
  fontSize: '18px',
  fontWeight: 600,
  color: Color.Purple600,
};
export const descriptionStyle = {
  fontSize: '14px',
  color: Color.TextPrimary,
  mt: 0.5,
};

export const amountStyle = {
  fontWeight: 700,
  color: Color.PrimaryMain,
};

export const totalAmountStyle = {
  color: Color.Purple600,
  fontWeight: 600,
  fontSize: '16px',
  mt: 2,
};
